import ContainerApFacturacion from "./ContainerApFacturacion";
import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
    Card,
    CardBody,
    Row,
    Col,
    Button,
} from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    listarColoresFetch,
    recuperarDatosFacturacionFetch,
} from "../../redux/actions/aCotizacion";
import "../../styles/table.scss";
import { useToasts } from 'react-toast-notifications';
import { FetchPost } from "../../redux/actions/api";
import { urlEnviarFVinculacionCliente } from "../../constants/urls";
import { getTituloFv } from "../../helpers/helpersFV";
import { consultarUsuarioFV } from "../../redux/actions/aFormularioVinculacion";
import { empresa } from "../../constants";

const ComponentApFacturacionFV = (props) => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { addToast } = useToasts();

    const [isLoading, setIsLoading] = useState(false);
    const [texto, setTexto] = useState("Cargando Formulario de Vinculación...");
    const [urlFormVinculacion, setUrlFormVinculacion] = useState("");
    const [back, setBack] = useState(false);
    const [yaTieneFormulario, setYaTieneFormulario] = useState(false);
    const [modulo, setModulo] = useState("");
    const [idCarrito, setIdCarrito] = useState(new URLSearchParams(location.search).get("id"));

    const dataFacturacion = useSelector(state => state.dataFacturacion);
    const formularioVinculacion = useSelector(state => state.rFormularioVinculacion);

    useEffect(() => {
        window.scrollTo(0, 0);
        const queryParams = new URLSearchParams(location.search);
        let url = queryParams.get("url");
        const regresar = queryParams.get("back");
        let tieneFormulario = queryParams.get("haveForm");
        const queryB64 = queryParams.get("query");
        const idDirecto = queryParams.get("id"); // ✅ Captura del ID directo

        const fetchData = async () => {
            let idCarritoFinal = null;

            if (queryB64) {
                const queryDecrypted = atob(queryB64);
                const queryAsObject = JSON.parse(queryDecrypted);
                idCarritoFinal = queryAsObject.idCarrito;
            } else if (idDirecto) {
                idCarritoFinal = idDirecto;
            }

            if (idCarritoFinal) {
                setIdCarrito(idCarritoFinal);

                await dispatch(consultarUsuarioFV({ content: "", id: idCarritoFinal }));
                const usuarioFv = formularioVinculacion && formularioVinculacion.usuarioFv;
                const transaccion = usuarioFv && usuarioFv.transaccion;
                const pasarPantallaFormulario = usuarioFv && usuarioFv.pasarPantallaFormulario;
                const urlFormulario = usuarioFv && usuarioFv.urlFormulario;

                if (transaccion) {
                    if (pasarPantallaFormulario) {
                        url = urlFormulario;
                    } else {
                        const datosJSON = {
                            empresa,
                            plataforma: "WEB",
                            idCarrito: idCarritoFinal,
                        };
                        await dispatch(recuperarDatosFacturacionFetch(datosJSON));

                        const df = dataFacturacion && dataFacturacion.datosFacturacion;
                         console.log("🚀 ~ fetchData ~ dataFacturacion:", dataFacturacion)
                        if (df && df.carDescripcionRamo && df.carDescripcionSeguro) {
                            const titulo = getTituloFv(df.carDescripcionRamo, df.carDescripcionSeguro);
                            tieneFormulario = titulo;
                        }
                    }
                }
            }

            if (url) {
                setUrlFormVinculacion(atob(url));
            }

            if (regresar) setBack(true);
            if (tieneFormulario) {
                setYaTieneFormulario(true);
                setModulo(tieneFormulario);
            }
        };

        fetchData();
    }, [dispatch, location.search]);
                       

    const onClickRegresar = () => {
        const queryParams = new URLSearchParams(location.search);
        let urlbackreturn = queryParams.get("urlbackreturn");

        if (urlbackreturn) {
            history.replace(atob(urlbackreturn));
        } else {
            history.goBack();
        }
    };

    const onClickEnviarFormulario = async () => {
        setIsLoading(true);
        setTexto("Enviando Formulario de Vinculación");

        const resp = await FetchPost({
            url: urlEnviarFVinculacionCliente + idCarrito,
            param: "",
        });

        setIsLoading(false);

        if (resp && resp.transaccion) {
            addToast("Formulario enviado al correo del cliente.", { appearance: "success" });
            history.replace("/principal");
        } else {
            addToast("No se pudo enviar el formulario. Intente nuevamente.", { appearance: "warning" });
        }
    };

    const onClickFinalizar = () => history.replace("/principal");

    const onClickPantallaFinal = () => {
        history.push({ pathname: props.datosCotizador.urlSiguiente, search: `?id=${idCarrito}` });
    };

    return (
        <ContainerApFacturacion paso={'formulario'} titulo={props.datosCotizador.titulo}>
            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <LoadingScreen
                            loading={
                                isLoading ||
                                (dataFacturacion && dataFacturacion.recuperarDatosFacturacionIsLoading) ||
                                (formularioVinculacion && formularioVinculacion.usuarioFvLoading)
                            }
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text={texto}
                        >
                            <Row>
                                <Col lg={12} className="detalle-cotizacion-box">
                                    <Card className="flex-row">
                                        <CardBody>
                                            {!yaTieneFormulario ? (
                                                <Row>
                                                    <Col lg={9}>
                                                        {back ? (
                                                            <Button className="button-white" onClick={onClickRegresar}>
                                                                <i className="fa fa-chevron-circle-left" /> REGRESAR AL DETALLE
                                                            </Button>
                                                        ) : (
                                                            <Button className="btn btn-purple" onClick={onClickEnviarFormulario}>
                                                                <i className="fa fa-paper-plane-o" /> ENVIAR FORMULARIO AL CLIENTE
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    <Col lg={3}>
                                                        {!back && (
                                                            <div>
                                                                <Button className="btn-secondary" onClick={onClickFinalizar}>
                                                                    <i className="fa fa-check" /> GESTIONAR MÁS TARDE
                                                                </Button>
                                                                <p className="leyenda-fv">
                                                                    Retomar desde Listado De Ventas, NO se enviará al cliente el link para llenar su formulario de vinculación
                                                                </p>
                                                            </div>
                                                        )}
                                                    </Col>
                                                    <Col lg={12}>
                                                        <div style={{ padding: "1em" }}>
                                                            <h2 style={{ color: "#001871", textAlign: "center" }}>COMPLETAR FORMULARIO DE VINCULACIÓN</h2>
                                                            <iframe className="iframe-fvinculacion" src={urlFormVinculacion} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row>
                                                    <Col lg={12}>
                                                        <div style={{ padding: "1em", textAlign: "center" }}>
                                                            <h2 style={{ color: "#001871" }}>FORMULARIO DE VINCULACIÓN VIGENTE</h2>
                                                            <p>El cliente ya tiene un Formulario de Vinculación vigente. Puede continuar haciendo clic en CONTINUAR.</p>
                                                            <Button className="btn-purple" onClick={onClickPantallaFinal}>
                                                                <i className="fa fa-check" /> CONTINUAR
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </LoadingScreen>
                    </div>
                </div>
            </main>
        </ContainerApFacturacion>
    );
};

export default ComponentApFacturacionFV;
